import React from 'react';
class ListaItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.items || [],
            opened: true,
            title: props.title || "title",
            index: props.items.length>0?props.items[0].id:null
        };
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidUpdate(prevProps) {
        let me = this;
        if (prevProps.items.length !== this.props.items.length) {
            this.setState({ index: this.props.items.length>0?this.props.items[0].id:null,data:this.props.items || [] });
        }
    }
    handleChange(item) {
        this.props.onChange(item);
        this.setState({ index: item.id });
    }
    render() {
        let me = this;
        let { title, opened, data,index } = this.state;
        if (data.length > 0) {
            return (
                <div
                    {...{
                        className: `accordion-item ${opened && 'accordion-item--opened'}`
                    }}
                >
                    <div {...{ className: 'accordion-item__line'}}>
                        <span {...{ className: 'accordion-item__title' }}>
                            {title}
                        </span>
                    </div>
                    <div {...{ className: 'accordion-item__inner' }}>
                        <div {...{ className: 'accordion-item__content' }}>
                            {data.map((item, key) => {
                                return (
                                    <div key={key} className="custom-control custom-radio mt-1" data-toggle="buttons" >
                                        <input   name="myradio" type="radio"  className="custom-control-input"
                                        id={item.id}
                                        label={item.nombre}
                                        checked={index==item.id}
                                        onChange= {() => { this.handleChange(item)}}
                                        />
                                        <label className="ml-2 custom-control-label" htmlFor={item.id}>{item.nombre}</label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )
        } else {
            return <div></div>;
        }
    }
}

export default ListaItem;